import { createSlice } from '@reduxjs/toolkit'
import { logFilterUsed } from '../fetch/insightsHelper';

export const defaultFiltersState = {
    query: '',
    families: [],
    type: '',
    group: [],
    searchTextBoxValue: '',
    language: '',
    state: 3,
    year: '',
    faultQuery: '',
    faultSearchTextBoxValue: '',
    serviceLogQuery: '',
    serviceLogSearchTextBoxValue: '',
}

export const libraryFiltersSlice = createSlice({
    name: 'libraryFilters',
    initialState: {
        ...defaultFiltersState
    },
    reducers: {
        executeDocumentQuery: (state, action) => {
            state.query = action.payload.trim();
            state.searchTextBoxValue = state.query;
            logFilterUsed('query', state.query);
        },
        clearDocumentQuery: (state) => {
            state.query = '';
            state.searchTextBoxValue = state.query;
        },
        changeFilter: (state, action) => {
            const { fieldName, value } = action.payload;
            if (state[fieldName] != value && 
                fieldName != 'searchTextBoxValue' && fieldName != 'faultSearchTextBoxValue' && fieldName != 'serviceLogSearchTextBoxValue') {
                logFilterUsed(fieldName, value);
            }
            state[fieldName] = value;
        },
        clearFilters: (state) => {
            state.query = defaultFiltersState.query;
            state.families = defaultFiltersState.families;
            state.type = defaultFiltersState.type;
            state.group = defaultFiltersState.group;
            state.searchTextBoxValue = defaultFiltersState.searchTextBoxValue;
            state.language = defaultFiltersState.language;
            state.state = defaultFiltersState.state;
            state.year = defaultFiltersState.year;
        },
        executeFaultQuery: (state, action) => {
            state.faultQuery = action.payload.trim();
            state.faultSearchTextBoxValue = state.faultQuery;
            logFilterUsed('faultQuery', state.faultQuery);
        },
        clearFaultQuery: (state) => {
            state.faultQuery = '';
            state.faultSearchTextBoxValue = state.faultQuery;
        },
        executeServiceLogQuery: (state, action) => {
            state.serviceLogQuery = action.payload.trim();
            state.serviceLogSearchTextBoxValue = state.serviceLogQuery;
            logFilterUsed('serviceLogQuery', state.serviceLogQuery);
        },
        clearServiceLogQuery: (state) => {
            state.serviceLogQuery = '';
            state.serviceLogSearchTextBoxValue = state.serviceLogQuery;
        }
    }
})

// Action creators are generated for each case reducer function
export const { changeFilter, clearFilters, executeDocumentQuery, clearDocumentQuery,
    executeFaultQuery, clearFaultQuery, executeServiceLogQuery, clearServiceLogQuery
 } = libraryFiltersSlice.actions

export default libraryFiltersSlice.reducer